<template>
    <base-page>
        <titlu-pagina Titlu="Reservations" @on_add_clicked="show_dialog()" :AdaugaVisible='true' />
        <el-card style='margin:5px 0px 5px 0px'>
            <div slot="header" class="clearfix">
                <strong> Filtre </strong>
            </div>
            <div class="filtre">
                <el-form @submit.prevent.native='refresh_info()'>
                    <el-row :gutter="20">                        
                        <el-col :md='24' >
                            <el-button type='primary' native-type='submit' @click='refresh_info()'> Aplica </el-button>
                        </el-col>
                    </el-row>
                </el-form>
                </div>
        </el-card>

        <el-table :data="Results" >
                <el-table-column prop='ClubName' label='Club Name'></el-table-column>
                <el-table-column prop='UserName' label='User Name'></el-table-column>
                <el-table-column label='RequestDate'>
                    <template slot-scope='scope'>
                        {{ scope.row.RequestDate | momentformat('dd.MM.YYYY HH:mm') }} 
                    </template>
                </el-table-column>
                <el-table-column label='EventDate'>
                    <template slot-scope='scope'>
                        {{ scope.row.EventDate | momentformat('dd.MM.YYYY') }}
                    </template>
                </el-table-column>
                <el-table-column prop='Description' label='Description'></el-table-column>
                <el-table-column prop='PriceInformation' label='PriceInformation'></el-table-column>
                <el-table-column prop='LadiesCount' label='LadiesCount'></el-table-column>
                <el-table-column prop='Status' label='Status'></el-table-column>
                <el-table-column fixed="right" align='right' label="Actiuni" width="200px" >
                    <template slot-scope="scope" >

                        

                        <el-tooltip content="Modificare">
                            <el-button type="primary" icon="el-icon-edit"  circle @click="show_dialog(scope.row.Id)" />
                        </el-tooltip>

                        <el-tooltip content="Validate" v-if="scope.row.Status=='pending'">
                            <el-button type="success" icon="el-icon-check"  circle @click="validate(scope.row.Id)" />
                        </el-tooltip>

                        <!-- <el-tooltip content="Sterge" >
                            <el-button type="danger" icon="el-icon-delete" circle @click="delete_item(scope.row)" />
                        </el-tooltip> -->

                    </template>
                </el-table-column>
            </el-table>
            <el-pagination @size-change="refresh_info" @current-change= "refresh_info" :page-size.sync="PaginationInfo.PerPage" :current-page.sync="PaginationInfo.Page" :total="PaginationInfo.RowCount" layout="pager" />
            <Reservations-dialog ref='dlg' @save="refresh_info()" />
    </base-page>
</template>

<script>
import settings from "@/backend/LocalSettings";
import BasePage from "@/pages/BasePage";
import Reservations_dialog from '@/pages/reservations/Reservations_dialog.vue';
import TitluPagina from '@/widgets/TitluPagina';

export default {
    name: "reservations",
    extends: BasePage,
    components: {
        'base-page': BasePage,
        'Reservations-dialog': Reservations_dialog,
        'titlu-pagina': TitluPagina
    },
    data () {
        return {
            Results: [],
            base_url: '',
            Info: { },
            Filters: { },
            OrderBy: { },
            PaginationInfo: { Page: 1, PerPage: 50, RowCount: 0, PageSizes: [10, 25, 50, 100, 200] },
        }
    },
    methods: {

        async get_info(){
            var response        = await this.post("reservations/get_info" );
                        this.refresh_info();
        },

        async refresh_info(){
            var response        = await this.post("reservations/index", { Filters: this.Filters, OrderBy: this.OrderBy, PaginationInfo: this.PaginationInfo } );
            this.Results        = response.Results;
            this.PaginationInfo = response.PaginationInfo;
            //
            this.select_menu_item('reservations');
        },
        reset(){
            this.Filters = {
                            };
            this.refresh_info();
        },

        async validate(id){
            var confirm = await this.$confirm(`Are you sure?`, 'Warning');
            
            if( confirm == 'confirm')
            {
                await this.post("reservations/validate", { id: id } );
                this.refresh_info();
            }
        },

        async delete_item( item ){
            var confirm =  await this.$confirm(`Sunteti sigur ?`, 'Warning');
            if( confirm )
            {
                await this.post("reservations/delete_item", { id: item.Id } );
                this.refresh_info();
            }
        },

        show_dialog(id){
            this.$refs.dlg.show_me(id);
        }
    },
    mounted(){
        this.base_url = settings.BASE_URL;
        this.get_info();
    }
};
</script>

<style lang="less" scoped>

    .top50{
        margin-top: 20px;
    }

    .filtre{
        .el-input-number
        {
            width: 100% !important;
        }
    }

</style>
